
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"205","height":"70","viewBox":"0 0 54.24 18.521"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M.661 16.324c0-1.115.274-3.25.574-4.47.893-3.64 2.4-6.428 4.652-8.6.978-.943 2.194-1.825 2.516-1.825.097 0 .622.297 1.166.661.9.602 1.594.997 3.105 1.767l.529.27.028 3.202.028 3.201h1.479V7.673c0-2.288.027-2.858.138-2.858.077 0 .565.145 1.085.321 1.09.37 2.563.751 3.856.997.495.095 1.007.195 1.138.223.237.05.238.06.238 2.112v2.062h1.694V6.612l.767.081c.996.104 6.302.104 7.09 0l.61-.08v3.917h1.554l.069-1.19c.038-.655.069-1.557.069-2.005 0-.448.048-.843.107-.88.058-.036.76-.2 1.56-.366a33.488 33.488 0 004.128-1.104l.767-.263v5.808h1.376V7.425c0-2.826.016-3.12.185-3.267.102-.089.686-.416 1.297-.727a26.238 26.238 0 002.202-1.294c.835-.558 1.149-.714 1.34-.666.418.105 1.861 1.251 2.758 2.19 1.72 1.803 2.783 3.635 3.706 6.393.691 2.066 1.106 4.453 1.106 6.362v.676h-5.503l-.002-.344c-.003-.6-.301-1.784-.622-2.47-.365-.78-1.046-1.556-1.647-1.878l-.428-.229H8.864l-.429.23c-.6.32-1.281 1.097-1.646 1.877-.321.686-.62 1.87-.622 2.47l-.002.344H.66z","fill":"#f0f0f0"}})])
          )
        }
      }
    